import script from "./HrBtn.vue?vue&type=script&setup=true&lang=js"
export * from "./HrBtn.vue?vue&type=script&setup=true&lang=js"

import "./HrBtn.vue?vue&type=style&index=0&id=4450693c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4450693c"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
